jQuery.widget("bluaul.ProjectOverview", jQuery.common.vcBaseV4, {
    // <summary>
    /// This widget is used to display a datacenter project overview as heatmap.
    /// </summary>

    vcV: new vcVisual(),
    vcC: new vcCommon(),

    myStatus: {
        errorType: "invalid",
        rangeStart: null,   // start point of range selection
        rangeEnd: null,     // end point of range selection
        selectedKeys: null  // selected data keys if range selection is used
        
    },

    _create: function () {
        var me = this;
        
        me._createVisual(399);
        me._super();
    },

    _initHTML: function () {
        /// <summary>
        /// This function initializes the HTML structure for the datacenter heatmap.
        /// </summary>

        var me = this;
        try {
            me._setRoot(".dc-project-overview");

            me._buildHtml();
            me._initEvents(); 

            me._setHeightsAndWidths();

            me._fetchHeatmap();
            
            return true;
        } catch (e) { me.writeError('_initHTML', e); return false; }
    },

    _buildHtml: function () {
        /// <summary>
        /// builds up the main structure
        /// </summary>
        var me = this;
        try {
            me.myHtml = { menu: {}, content: {} };

            var obj = me.myHtml.menu;

            obj.wrapper = me._setObj("div-menu", "vc-grid-margin-bottom").css({
                width: "100%",
                height: "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "12px"
            });

            // reload button
            obj.btnReload = me._setMainButton("btn-reload", me.specific.resources.iconReload, me.specific.resources.reload).addClass("active");

            // date container
            obj.dateContainer = me._setObj("div-date-container", "optionbox vc-grid-2col float-box vc-grid-margin-left");

            // date box
            obj.dateBox = me._setObj("div-date", "vc-date-box");
            obj.dateContainer.append(obj.dateBox);

            // type buttons - inplausible / missing / invalid
            obj.typeContainer = me._setObj("div-type-container", "optionbox vc-grid-2col float vc-grid-margin-left");
            obj.filterBox = me._setObj("div-filter-box", "vc-option-box");
            obj.typeContainer.append(obj.filterBox); 

            // checkbox container
            obj.signalSelection = me._setObj("div-filter-container", "optionbox float-box vc-grid-margin-left").css({display: "flex", alignItems: "center", gap: "6px", paddingLeft: "6px" });

            // checkbox + label
            obj.chkSelectedSignals = $("<input>", { id: "chk-selected-signals", type: "checkbox" });
            obj.lblSelectedSignals = $("<label>", { "for": "chk-selected-signals" }).text("nur selektierte Signale");
            obj.signalSelection.append(obj.chkSelectedSignals, obj.lblSelectedSignals);

            obj.wrapper.append(obj.btnReload, obj.dateContainer, obj.typeContainer, obj.signalSelection);

            // content area
            me.myHtml.content = me._setObj("div-content", "vc-grid-margin-right float").css("width", "70%").css("height", "85%");

            me.myRoot.append(obj.wrapper, me.myHtml.content);

        } catch (e) { me._writeErr(e); }
    },

    _initFilterBox: function () {
        var me = this;
        try {

            let obj = me.myHtml.menu;
            var fVal = $("<div>").attr("id", "div-filter-val");
            fVal.append($("<div>", { "data-type": "invalid" }).addClass("invalid-signal").html(me.specific.resources.iconDsInvalid).button());
            fVal.append($("<div>", { "data-type": "inplausible" }).addClass("invalid-signal").html(me.specific.resources.iconDsInplaus).button());
            fVal.append($("<div>", { "data-type": "missing" }).addClass("invalid-signal").html(me.specific.resources.iconDsMissing).button());


            obj.filterBox.vcOptionBox({
                caption: me.specific.resources.selection,
                items: [
                    { button: me.specific.resources.filter, clickable: true, content: fVal },
                ], callback: function () { }
            });

        } catch (e) { me._writeErr(e); }
    }, 

    _initEvents: function () {        
        var me = this;
        try {

            // default date range: current year
            var yearStart = moment().startOf("year").format("DD.MM.YYYY");
            var yearEnd = moment().endOf("year").format("DD.MM.YYYY");

            // date box init
            me.myHtml.menu.dateBox.vcDateBox({
                mode: "Range",
                align: "right",
                interval: 1,
                defaultRange: { from: yearStart, to: yearEnd },
                langID: me.settings.userLangIDForCulture,
                callback: function (obj) {
                }
            });


            me._initFilterBox();




            me.myStatus.errorType = (me.specific.startParam && me.specific.startParam.ErrorType) ? me.specific.startParam.ErrorType : "invalid";
            me._setErrorType(me.myStatus.errorType);

            // click events for type buttons
            me.myHtml.menu.filterBox.find(".invalid-signal").off("click").on("click", function () {
                var btn = $(this);
                var type = $(this).attr("data-type"); // inplausible / missing / invalid

                // only a button can be active
                me.myStatus.errorType = type;
                me._setErrorType(type);
            });

            // reload button
            me.myHtml.menu.btnReload.off("click").on("click", function () {
                me._fetchHeatmap();
            });

            me.myStatus.useSelectedSignals = false;

            // checkbox only selected signals
            me.myHtml.menu.chkSelectedSignals.off("change").on("change", function () {
                me.myStatus.useSelectedSignals = $(this).is(":checked");

                me.myStatus.rangeStart = null;
                me.myStatus.rangeEnd = null;

                // reload heatmap
                me._fetchHeatmap();
            });


        } catch (e) { me._writeErr(e); }
    },

    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function sets heights and widths of the elements.
        /// </summary>
        var me = this;
        try {
            var h = me.myHtml.menu.dateBox.outerHeight();
            me.myHtml.menu.typeContainer.outerHeight(h);
            me.myHtml.menu.filterBox.outerHeight(h);


        } catch (e) { me._writeErr(e); }
    },


    _setErrorType: function (type) {
        /// <summary>
        /// This function sets the active error filter type button.
        /// </summary>
        var me = this;
        try {
            type = (type || "invalid") + "";

            var typeButtons = me.myHtml.menu.filterBox.find(".invalid-signal");
            typeButtons.removeClass("button-toggle-active");
            var btn = typeButtons.filter("[data-type='" + type + "']");

            if (!btn.length) btn = typeButtons.filter("[data-type='invalid']");
            btn.addClass("button-toggle-active");

        } catch (e) { me._writeErr(e); }
    },

    _fetchHeatmap: function () {
        /// <summary>
        /// This function fetches the heatmap data and renders it.
        /// </summary>
        var me = this;
        try {
            me._setLoadingIcon(me.myHtml.content);

            me.myStatus.rangeStart = null;
            me.myStatus.rangeEnd = null;

            var dateRange = me.myHtml.menu.dateBox.vcDateBox("getDateRange");
            var errorType = me.myStatus.errorType || "invalid"; // invalid as default

            var param = { TypeId: 0, StartDate: dateRange.from, EndDate: dateRange.to, ErrorType: errorType, UseSelectedBsaids: me.myStatus.useSelectedSignals };

            me.getData(param, function (result) {
                me._renderYearHeatmap(result);
            });
        } catch (e) { me._writeErr(e); }
    },


    _renderYearHeatmap: function (rows) {
        /// <summary>
        /// This function renders the year heatmap using Highcharts.
        /// </summary>
        try {
            var me = this;            

            var errorType = me.myStatus.errorType || "invalid";

            var valueField;
            var seriesTitle;
            var tooltipLabel;

            switch (errorType) {
                case "missing":
                    valueField = "missing";
                    seriesTitle = "Missing";
                    tooltipLabel = "missing";
                    break;

                case "invalid":
                    valueField = "invalid";
                    seriesTitle = "Invalid";
                    tooltipLabel = "invalid";
                    break;

                case "inplausible":
                default:
                    valueField = "inplaus";
                    seriesTitle = "Inplausibilität";
                    tooltipLabel = "inplaus";
                    break;
            }

            // get all rows
            if (rows && rows.rows && Array.isArray(rows.rows)) {
                rows = rows.rows;
            }

            if (!Array.isArray(rows)) rows = [];

            // months 01 - 12 on x-axis
            var monthCategories = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

            // days 01 - 31 on y-axis
            var dayCategories = [];
            for (var d = 1; d <= 31; d++) {
                dayCategories.push(d.toString());
            }

            var firstYear = null;

            // we map the data points by "month-day" for easier access
            var pointMap = Object.create(null);
            var minVal = 0; // Number.POSITIVE_INFINITY;
            var maxVal = 150; // Number.NEGATIVE_INFINITY;

            $.each(rows, function (i, row) {
                if (!row.day) { return; }

                var dt;
                if (row.day instanceof Date) {
                    dt = row.day;
                } else {
                    dt = new Date(row.day);
                }

                if (isNaN(dt.getTime())) return;

                var monthIndex = dt.getMonth();   // month index from 0-11
                var dayIndex = dt.getDate() - 1;  // day index from 0-30

                if (firstYear === null) firstYear = dt.getFullYear();

                // we get the value for the specific field depending on error type
                var raw = (typeof row[valueField] !== "undefined") ? row[valueField] : null;
                var value = raw != null ? parseInt(raw, 10) : null;
                if (isNaN(value)) { value = null; }

                var isEmpty = (value == null || value === 0);

                var key = monthIndex + "-" + dayIndex;

                pointMap[key] = {
                    x: monthIndex,
                    y: dayIndex,
                    value: isEmpty ? null : value,
                    isEmpty: isEmpty,
                    date: dt.toLocaleDateString(),
                    isValidDay: true
                };

                //if (value != null) {
                //    if (value < minVal) minVal = value;
                //    if (value > maxVal) maxVal = value;
                //}
            });

            // fallbacks for scale, if no valid values found
            if (!isFinite(minVal)) minVal = 0;
            if (!isFinite(maxVal)) maxVal = 1;
            if (firstYear === null) {
                try {
                    var dr = me.myHtml.menu.dateBox.vcDateBox("getDateRange");
                    if (window.moment && dr && dr.from) firstYear = moment(dr.from, "DD.MM.YYYY").year();
                    else firstYear = (new Date()).getFullYear();
                } catch (e) {
                    firstYear = (new Date()).getFullYear();
                }
            }

            // we construct the full data array for all months and days
            var dataValues = [];     // real values
            var dataEmptyWhite = []; // null cells with white color
            var dataEmptyGrey = [];  // null cells with grey color
            var dataInvalidDays = []; // invalid days (like 30.02.)
            for (var m = 0; m < 12; m++) {
                // we need to know how many days the current month has, because not all months have 31 days
                var daysInMonth = new Date(firstYear, m + 1, 0).getDate();

                for (var dIdx = 0; dIdx < 31; dIdx++) {
                    var key = m + "-" + dIdx;

                    if (pointMap[key]) {
                        var pt = pointMap[key];

                        if (!pt.isValidDay) {
                            
                        } else if (pt.value == null) {                            
                            if (((pt.x + pt.y) % 2) === 0) dataEmptyWhite.push(pt);
                            else dataEmptyGrey.push(pt);
                        } else {
                            dataValues.push(pt);
                        }
                    } else {
                        // if no data point exists, we need to check if the day is valid for the month
                        var isValidDay = (dIdx + 1) <= daysInMonth;

                        if (isValidDay) {
                            // if valid day, we add a point with null value
                            var dtEmpty = new Date(firstYear, m, dIdx + 1);

                            var emptyPt = {
                                x: m,
                                y: dIdx,
                                value: null,
                                isEmpty: true,
                                date: dtEmpty.toLocaleDateString(),
                                isValidDay: true
                            };

                            if (((m + dIdx) % 2) === 0) dataEmptyWhite.push(emptyPt);
                            else dataEmptyGrey.push(emptyPt);
                        } else {
                            // invalid days like 30.02.
                            var invalidPt = {
                                x: m,
                                y: dIdx,
                                value: null,
                                isEmpty: true,
                                isValidDay: false,
                                date: "" // has no date!
                            };
                            dataInvalidDays.push(invalidPt);
                        }
                    }
                }
            }

            // we prepare the Highcharts options
            var chartTheme;
            try {
                var ro = new RampOptions();
                ro.deviceType = me.specific.deviceType || 1;
                ro.mobile = false;
                ro.width = me.options.invoke.container.width;
                chartTheme = ro.getTheme();
            } catch (e) {
                chartTheme = {};
            }

            var renderTarget = me.myHtml.content[0];
            me.myHtml.content.empty();

            var hcOptions = Highcharts.merge(chartTheme, {
                chart: {
                    renderTo: renderTarget,
                    type: "heatmap",
                    height: me.myHtml.content.height(),
                    marginTop: 20,
                    spacingBottom: 20,
                    spacingRight: 10
                },
                title: { text: "" },
                boost: { enabled: false },
                xAxis: {
                    categories: monthCategories,
                    title: { text: "Monate" },
                    tickInterval: 1,
                    min: 0,
                    max: 11
                },
                yAxis: {
                    categories: dayCategories,
                    title: { text: "Tage" },
                    reversed: false,
                    tickInterval: 1
                },
                legend: {
                    align: "right",
                    layout: "vertical",
                    margin: 10,
                    verticalAlign: "middle",
                    symbolHeight: 200
                },
                colorAxis: {
                    min: minVal,
                    max: maxVal,
                    minColor: "#ffe5e5",   // light red
                    maxColor: "#b30000",   // dark red
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: [0, 25, 50, 75, 100, 125, 150],
                    labels: {
                        formatter: function () {
                            return (this.value === maxVal) ? (maxVal + "+") : this.value;
                        }
                    }
                    //labels: {
                    //    formatter: function () {
                    //        if (this.value >= maxVal) {
                    //            return maxVal + "+";
                    //        }
                    //        return this.value;
                    //    } }
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        boostThreshold: 999999,
                        allowPointSelect: true,
                        states: {
                            select: {
                                enabled: true,
                            }
                        },
                        dataLabels: {
                            enabled: true,
                            formatter: function () {
                                if (!this.point.isValidDay) return "";
                                if (this.point.isEmpty) return "";
                                if (this.point.value === 0) return "";
                                if (this.point.value == null) return "";
                                return this.point.value;
                            }
                        },
                        states: {
                            hover: {
                                enabled: true,
                                brightness: 0, // we do not want the default brightness change on hover
                                opacity: 1,
                                halo: { size: 0 }
                            }
                        },
                        point: {
                            events: {
                                click: function (ev) {
                                    //ev = ev || window.event || {}; // Fallback
                                    var p = this;
                                    var owner = p.series.chart.__ownerWidget || null;
                                    if (!owner) return;

                                    // only valid days can be clicked (even if there is no value)
                                    if (!p.isValidDay) return;

                                    var info = owner._pointToDateInfo(p, firstYear);

                                    // we check if CTRL key is pressed for range selection
                                    var ctrl = !!(ev && (ev.ctrlKey || ev.metaKey));

                                    // we check if SHIFT key is pressed for reset
                                    var reset = !!(ev && ev.shiftKey);

                                    if (reset) {
                                        owner._clearRangeSelection(p.series.chart);
                                        return;
                                    }

                                    if (ctrl) {
                                        // we check if range start is already set; first click = start, second click = end
                                        if (!owner.myStatus.rangeStart) {
                                            owner._clearRangeSelection(p.series.chart);
                                            owner.myStatus.rangeStart = info;
                                            owner.myStatus.rangeEnd = info;          // start = end
                                            owner._applyRangeSelection(p.series.chart, firstYear);
                                            return;
                                        } else {
                                            owner.myStatus.rangeEnd = info;
                                            // we mark the range in the chart
                                            owner._applyRangeSelection(p.series.chart, firstYear);

                                            // we get the range dates
                                            var fromTs = Math.min(owner.myStatus.rangeStart.ts, owner.myStatus.rangeEnd.ts);
                                            var toTs = Math.max(owner.myStatus.rangeStart.ts, owner.myStatus.rangeEnd.ts);

                                            // we get the date strings (we need strings in DD.MM.YYYY format)
                                            var fromStr = (window.moment) ? moment(fromTs).format("DD.MM.YYYY") : owner.myStatus.rangeStart.dateStr;
                                            var toStr = (window.moment) ? moment(toTs).format("DD.MM.YYYY") : owner.myStatus.rangeEnd.dateStr;

                                            // send selection via VCMQ
                                            if (owner.options && owner.options.invoke && owner.options.invoke.vcgid && typeof _VCMQ !== "undefined") {
                                                _VCMQ.produce(owner.visual, owner.options.invoke.vcgid, "DC_PROJECT_OVERVIEW_SELECT_RANGE",
                                                    {
                                                        from: fromStr,
                                                        to: toStr,
                                                        errorType: owner.myStatus.errorType || "invalid"
                                                    }
                                                );
                                            }

                                            // we directly close the dialog after range selection
                                            if (owner.element) {
                                                owner.element.closest(".ui-dialog-content").dialog("close");
                                            }

                                            return;
                                        }
                                    }

                                    // normal click without CTRL = single day selection
                                    if (owner.options && owner.options.invoke && owner.options.invoke.vcgid && typeof _VCMQ !== "undefined") {
                                        _VCMQ.produce(owner.visual, owner.options.invoke.vcgid, "DC_PROJECT_OVERVIEW_SELECT_DAY",
                                            {
                                                date: info.dateStr,
                                                errorType: owner.myStatus.errorType || "invalid"
                                            }
                                        );
                                    }

                                    if (owner.element) {
                                        owner.element.closest(".ui-dialog-content").dialog("close");
                                    }
                                },

                                mouseOver: function () {
                                    if (!this.isValidDay) {
                                        var ch = this.series && this.series.chart;
                                        if (ch && ch.tooltip) ch.tooltip.hide(0);
                                        ch && ch.pointer && ch.pointer.reset && ch.pointer.reset();
                                        this.series.chart.renderTo.style.cursor = "default";
                                        return;
                                    }
                                    this.series.chart.renderTo.style.cursor = "pointer";

                                    var owner = this.series.chart.__ownerWidget;
                                    if (!owner) return;

                                    // if range selection is active, we make a preview range to this point
                                    if (owner.myStatus && owner.myStatus.rangeStart) {
                                        owner._previewRangeToPoint(this.series.chart, firstYear, this);
                                        return; 
                                    }

                                    // default hover if no range selection
                                    var okGreen = owner._getThemeOkGreen();
                                    if (!okGreen) return;

                                    if (this.graphic && this.graphic.element) {
                                        var el = this.graphic.element;

                                        if (typeof this.__origFill === "undefined") this.__origFill = el.getAttribute("fill") || "";
                                        if (typeof this.__origFillOpacity === "undefined") this.__origFillOpacity = el.getAttribute("fill-opacity");
                                        if (typeof this.__origOpacity === "undefined") this.__origOpacity = el.getAttribute("opacity");

                                        el.setAttribute("fill", okGreen);
                                        el.setAttribute("fill-opacity", "1");
                                        el.setAttribute("opacity", "1");
                                    }
                                },

                                mouseOut: function () {
                                    this.series.chart.renderTo.style.cursor = "default";

                                    var owner = this.series.chart.__ownerWidget;
                                    if (!owner) return;

                                    // if range selection is active, we restore the range to start only
                                    if (owner.myStatus && owner.myStatus.rangeStart) {
                                        owner._restoreRangeToStartOnly(this.series.chart, firstYear);
                                        return;
                                    }

                                    // default single point hover out
                                    if (this.graphic && this.graphic.element) {
                                        var el = this.graphic.element;

                                        if (this.__origFill) el.setAttribute("fill", this.__origFill);
                                        else el.removeAttribute("fill");

                                        if (this.__origFillOpacity == null) el.removeAttribute("fill-opacity");
                                        else el.setAttribute("fill-opacity", this.__origFillOpacity);

                                        if (this.__origOpacity == null) el.removeAttribute("opacity");
                                        else el.setAttribute("opacity", this.__origOpacity);
                                    }
                                }



                            }
                        }
                    }
                },
                series: [
                    // empty cells - white color
                    {
                        name: "EmptyWhite",
                        data: dataEmptyWhite,
                        nullColor: "#ffffff",
                        colorAxis: false,
                        showInLegend: false,
                        enableMouseTracking: true,
                        borderWidth: 0
                    },
                    // empty cells - grey color
                    {
                        name: "EmptyGrey",
                        data: dataEmptyGrey,
                        nullColor: "#f0f0f0",
                        colorAxis: false,
                        showInLegend: false,
                        enableMouseTracking: true,
                        borderWidth: 0
                    },
                    // real values - correct color axis
                    {
                        name: seriesTitle,
                        data: dataValues,
                        turboThreshold: Number.MAX_VALUE,
                        borderWidth: 0
                    },
                    // invalid days, no tooltip, no hovering
                    {
                        name: "InvalidDays",
                        data: dataInvalidDays,
                        nullColor: "#ffffff",       
                        colorAxis: false,
                        showInLegend: false,
                        enableMouseTracking: false,  // no hovering/click/tooltip
                        borderWidth: 0,
                        states: { hover: { enabled: false } }
                    }

                ],
                tooltip: {
                    hideDelay: 0,
                    formatter: function () {
                        var p = this.point;

                        // if point is not a valid day, we show no tooltip
                        if (!p || p.isValidDay === false) return false;

                        if (p.value == null) return "<b>" + (p.date || "") + "</b>";

                        // otherwise we show the tooltip with date and value
                        return "<b>" + (p.date || "") + "</b><br/>";
                    }
                },
                exporting: {
                    enabled: false
                }
            });


            // we create the chart  
            var chart = new Highcharts.chart(hcOptions);
            chart.__ownerWidget = me;

            // we adjust the select state color to our button-toggle-active color
            var okGreen = me._getThemeOkGreen() || "#66bb66";
            chart.update({
                plotOptions: {
                    series: {
                        states: {
                            select: {
                                color: okGreen,
                                borderColor: okGreen
                            }
                        }
                    }
                }
            }, false);
            chart.redraw(false);

            // we store the chart instance globally for access from outside if needed
            chart.__ownerWidget = me;
            window.__GLOBAL_VISUAL_LIST = window.__GLOBAL_VISUAL_LIST || {};
            window.__GLOBAL_VISUAL_LIST["projectOverviewYearHeatmap"] = chart;
        } catch (e) { me._writeErr(e); }
    },

    _getThemeOkGreen: function () {
        /// <summary>
        /// This function retrieves the "button-toggle-active" color from the CSS.
        /// </summary>
        try {
            // we get the button-toggle-active color from CSS
            var dummy = document.createElement("span");
            dummy.className = "button-toggle-active";
            dummy.style.cssText = "position:absolute;left:-9999px;top:-9999px;visibility:hidden;";
            document.body.appendChild(dummy);

            var cs = getComputedStyle(dummy);
            var bg = cs.backgroundColor; // we need the background color of the button
            var col = cs.color;

            document.body.removeChild(dummy);

            // fallback if no background color found
            if (!bg || bg === "transparent" || bg === "rgba(0, 0, 0, 0)") {
                return col || null;
            }
            return bg;
        } catch (e) { me._writeErr(e); }
    },   

    _pointToDateInfo: function (p, firstYear) {
        /// <summary>
        /// This function converts a Highcharts point to date info.
        /// </summary>
        try {
            // p: Highcharts point (x=monthIdx 0..11, y=dayIdx 0..30)
            var year = firstYear;
            var month = p.x + 1;
            var day = p.y + 1;

            var ts = new Date(year, month - 1, day).getTime();

            var dateStr;
            if (window.moment) dateStr = moment([year, month - 1, day]).format("DD.MM.YYYY");
            else {
                var d = ("0" + day).slice(-2);
                var m = ("0" + month).slice(-2);
                dateStr = d + "." + m + "." + year;
            }

            return { x: p.x, y: p.y, dateStr: dateStr, ts: ts };
        } catch (e) { me._writeErr(e); }
    },

    _clearRangeSelection: function (chart) {
        /// <summary>
        /// This function clears the current range selection.
        /// </summary>
        try {
            var me = this;
            me.myStatus.rangeStart = null;
            me.myStatus.rangeEnd = null;
            me.myStatus._previewEnd = null;

            if (!chart || !chart.series) return;

            chart.series.forEach(function (s) {
                if (!s || !s.points) return;
                s.points.forEach(function (pt) {
                    if (pt && pt.selected) pt.select(false, true);
                });
            });
        } catch (e) { me._writeErr(e); }
    },

    _applyRangeSelection: function (chart, firstYear) {
        /// <summary>
        /// This function applies the current range selection to the chart.
        /// </summary>
        try {
            var me = this;
            if (!chart || !chart.series) return;

            var s = me.myStatus.rangeStart;
            var e = me.myStatus.rangeEnd;
            if (!s || !e) return;

            var from = Math.min(s.ts, e.ts);
            var to = Math.max(s.ts, e.ts);

            // deselect all
            chart.series.forEach(function (ser) {
                if (!ser || !ser.points) return;
                ser.points.forEach(function (pt) {
                    if (pt && pt.selected) pt.select(false, true);
                });
            });

            // select range across all series
            chart.series.forEach(function (ser) {
                if (!ser || !ser.points) return;
                ser.points.forEach(function (pt) {
                    if (!pt || !pt.isValidDay) return;
                    var info = me._pointToDateInfo(pt, firstYear);
                    if (info.ts >= from && info.ts <= to) pt.select(true, true);
                });
            });
        } catch (e) { me._writeErr(e); }
    },

    _previewRangeToPoint: function (chart, firstYear, hoverPoint) {
        /// <summary>
        /// This function previews the range selection to the hovered point.
        /// </summary>
        try {
            var me = this;
            if (!chart || !chart.series || !chart.series[0]) return;
            if (!me.myStatus.rangeStart) return;

            // only valid days shall be marked
            if (!hoverPoint || !hoverPoint.isValidDay) return;

            var info = me._pointToDateInfo(hoverPoint, firstYear);

            // we store the preview end point
            me.myStatus._previewEnd = info;

            // temporarily set range end to preview end for marking
            me.myStatus.rangeEnd = info;
            me._applyRangeSelection(chart, firstYear);
        } catch (e) { me._writeErr(e); }
    },

    _restoreRangeToStartOnly: function (chart, firstYear) {
        /// <summary>
        /// This function restores the range selection to the start point only.
        /// </summary>
        try {
            var me = this;
            if (!me.myStatus.rangeStart) return;

            me.myStatus.rangeEnd = me.myStatus.rangeStart;
            me.myStatus._previewEnd = null;
            me._applyRangeSelection(chart, firstYear);
        } catch (e) { me._writeErr(e); }
    },

    _getEmptyCellColor: function (m, dIdx) {
        return ((m + dIdx) % 2 === 0) ? "#ffffff" : "#f0f0f0";
    },


    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) { }
            return true;
        } catch (e) { me.writeError('specificInfoHandling', e); return false; }
    }


});


